import { HashTable } from './HashTable';
export class HashtableLightCount extends HashTable {
    constructor() {
        super(...arguments);
        this.hasValues = false;
    }
    get HasValues() {
        return this.hasValues;
    }
    set HasValues(value) {
        this.hasValues = value;
    }
    Set(key, value) {
        super.Set(key, value);
        this.HasValues = true;
        return this.Get(key);
    }
    Clear(key) {
        super.Clear(key);
        this.HasValues = false;
    }
    get Count() {
        return this.counter;
    }
}
